// extracted by mini-css-extract-plugin
module.exports = {"caseResult":"style_caseResult__n_5Gb","caseResult__title":"style_caseResult__title__bEy78"};